// Константы для онлайн-записи — единый источник правды в web-booking
import { BUSINESS_DEFAULTS } from '@minibook/shared';

export { UI_CONSTANTS } from '@minibook/shared';

/** Формат даты для API (YYYY-MM-DD). Совпадает с бэкендом. */
export const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/** Диапазон календаря в днях от «сегодня» (совпадает с типичным maxBookingDays на бэке). */
export const CALENDAR_RANGE_DAYS = 60;

/** Таймзона по умолчанию, если у мастера не пришла. Override: VITE_DEFAULT_TIMEZONE. */
export const DEFAULT_TIMEZONE =
  (import.meta as ImportMeta).env?.VITE_DEFAULT_TIMEZONE?.trim() || BUSINESS_DEFAULTS.DEFAULT_TIMEZONE;

/** Дефолт retry-after (сек) при rate limit, если бэкенд не вернул. */
export const RATE_LIMIT_RETRY_AFTER_DEFAULT_SEC = 60;

/** URL бэкенда по умолчанию (dev), если VITE_API_URL не задан. */
export const DEFAULT_API_URL = 'http://localhost:3000';
